export function resolveApiBaseUrl({ configured = "", hostname = "" } = {}) {
  const explicit = String(configured || "").trim();
  if (explicit) return explicit;
  return hostname === "localhost" || hostname === "127.0.0.1"
    ? "http://127.0.0.1:8000"
    : "/api";
}
